query MigrationShowQuery($id: ID!) {
  migration(id: $id) {
    id
    title
    status
    error
    attemptsMade
    lastRunAt
    createdAt
  }
}
